
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationF as ObiLocationFElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-f.js';
 
 
 

 
 export const ObiLocationF = createComponent({
   react: React,
   tagName: 'obi-location-f',
   elementClass: ObiLocationFElement,
   events: {
     
   }
  });
 
 